module.exports = __webpack_public_path__ + "static/media/mano.26f5e7ba.jpg";